// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pagination-container[data-v-6b9b39ed]{background:#fff;padding:32px 16px}.pagination-container.hidden[data-v-6b9b39ed]{display:none}", ""]);
// Exports
module.exports = exports;
